import httpAxios, { httpAxiosPublic } from '@/utils/http.utils';
import { AxiosResponse } from 'axios';
import ConfigUtils from '@/utils/config.utils';
import { IRetailer } from '@/models/retailer';
import Registration from '@/models/registration';

const retailerApi = ConfigUtils.getAppConfiguration().taftRetailerApiUrl ?? '';
export default class RetailerService {
  static async getRetailers(): Promise<AxiosResponse<IRetailer> | AxiosResponse<IRetailer[]>> {
    return httpAxios.get(retailerApi);
  }

  static async getAllRetailers(): Promise<AxiosResponse<IRetailer[]>> {
    return httpAxios.get(`${retailerApi}/all`);
  }

  static async verifyEmail(token: string): Promise<AxiosResponse> {
    return httpAxiosPublic.post(`${retailerApi}/verification`, { data: token });
  }

  static async requestRegistration(registration: Registration) {
    return httpAxiosPublic.post(`${retailerApi}/registration`, registration);
  }
}
